import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import CompanyForm from './Form';
import SubscriptionsTab from './SubscriptionsTab';



const Company: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const isEdit = Boolean(id);

  return (
    <>
      {isEdit ? (
        <Tabs defaultActiveKey="basicInfo" id="company-form-tabs">
          <Tab eventKey="basicInfo" title="Basic Info">
            <CompanyForm />
          </Tab>
        
          <Tab eventKey="subscriptions" title="Subscriptions">
            <SubscriptionsTab companyId={+id!} /> {/* Pass the companyId to the SubscriptionsTab */}
          </Tab>
        </Tabs>
      ) : (
        <CompanyForm />
      )}
    </>
  );
};

export default Company;